module.exports = "pegasus_template/assets/themecapture1/scratch/102.png";